import { getPhoneNumberCountryCodeAsNumber } from 'lib-shared-phone-numbers';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import { appActions } from 'app/app.actions';
import { RootReducerStateT } from 'app/reducers/rootReducer';
import { AppDispatch } from 'bootstrap.store';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';

import { notificationActions } from '../../../notifications/actions/notification';
import * as telephonyActions from '../../../telephony/actions/telephony';
import { transferToAgentActions } from '../actions/transferToAgentModal';
import { TransferToAgentModalWrapper } from '../components/transferToAgentModalWrapper';

const { telephonyResetHold } = telephonyActions.actions;
const { notificationAdd, notificationRemoveByType } = notificationActions;

export type StateProps = ReturnType<typeof mapStateToProps>;
export type DispatchProps = ReturnType<typeof mapDispatchToProps>;

const getSelectedFromNumber = (state: RootReducerStateT) =>
  state.telephony.selectedFromNumber;
const selectFromNumberCountryCode = createSelector(
  getSelectedFromNumber,
  (selectedFromNumber: ReturnType<typeof getSelectedFromNumber>) => {
    const DEFAULT_PREFIX = 45;
    if (selectedFromNumber) {
      return (
        getPhoneNumberCountryCodeAsNumber(selectedFromNumber.e164_format) ||
        DEFAULT_PREFIX
      );
    }
    return DEFAULT_PREFIX;
  },
);

const mapStateToProps = (state: RootReducerStateT) => {
  return {
    meta: state.transferToAgent.meta,
    ui: state.transferToAgent.ui,
    metaConversation: state.transferToAgent.metaConversation,
    presenceMeta: state.presence.meta,
    profile: state.settings.profile.profile,
    presence: state.presence.presence,
    transferToQueueRequests: state.transferToQueue.requests,
    transferToAgentRequests: state.transferToAgent.transferRequests,
    numberTransferRequests: state.transferToNumber.transferRequests,
    fromNumberCountryCode: selectFromNumberCountryCode(state),
    queueId: state.transferToAgent.queueId,
  };
};

const mapDispatchToProps = (dispatch: AppDispatch) => {
  return {
    transferToAgentAssistedRequest: bindActionToPromise(
      dispatch,
      transferToAgentActions.transferToAgentAssistedRequest,
    ),
    transferToAgentBlindRequest: bindActionToPromise(
      dispatch,
      transferToAgentActions.transferToAgentBlindRequest,
    ),
    transferToAgentAssistedResolve: bindActionToPromise(
      dispatch,
      transferToAgentActions.transferToAgentAssistedResolve,
    ),

    transferToAgentModalClose: () =>
      dispatch(transferToAgentActions.transferToAgentModalClose()),
    transferRequestStop: (
      csid: StateProps['metaConversation']['conversation']['id'],
    ) => dispatch(transferToAgentActions.transferToAgentRequestStop({ csid })),
    transferToAgentShowMessageModal: () =>
      dispatch(transferToAgentActions.transferToAgentShowMessageModal()),
    transferToAgentHideMessageModal: () =>
      dispatch(transferToAgentActions.transferToAgentHideMessageModal()),

    notificationAdd: (payload: any) => dispatch(notificationAdd(payload)),
    notificationRemoveByType: (payload: any) =>
      dispatch(notificationRemoveByType(payload)),

    telephonyResetHold: () => dispatch(telephonyResetHold()),

    openQueueTransferModal: (csid: number) =>
      dispatch(
        appActions.showModal({
          modal: {
            type: 'app:conversationQueueTransfer',
            arg: { csid, isWarmTransferAvailable: true },
          },
        }),
      ),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TransferToAgentModalWrapper);
